import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// POST: Create a new business
export const createBusiness = createAsyncThunk(
  "business/createBusiness",
  async (businessData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://api.aweioio.com/api/businesses",
        businessData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateBusinessHours = createAsyncThunk(
  "business/updateBusinessHours",
  async ({ businessId, hours }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `https://api.aweioio.com/api/businesses/${businessId}/hours`,
        { hours }
      );
      return response.data;  // => the updated hours object
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const fetchMenuItems = createAsyncThunk(
  "menu/fetchMenuItems",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://api.aweioio.com/api/menu-items");
      return response.data.menuItems; // Return the menu items
    } catch (error) {
      console.error(
        "Error fetching menu items:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchBusinesses = createAsyncThunk(
  "business/fetchBusinesses",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://api.aweioio.com/api/businesses");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchBusinessById = createAsyncThunk(
  "business/fetchBusinessById",
  async (businessId, { rejectWithValue }) => {
    console.log(businessId,"businessId")
    try {
      const response = await axios.get(
        `https://api.aweioio.com/api/businesses/${businessId}`
      );
      return response.data;
    } catch (error) {
      console.log("dsss",error)
      return rejectWithValue(error.response.data);
    }
  }
);



// Initial state for the business slice
const initialState = {
  businesses: [],
  menuItems: [],
  business: null, // This will store a single business if fetched by ID
  loading: false,
  error: null, hoursUpdating: false,
  hoursError: null,
};

// Create the business slice
const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create a new business
      .addCase(createBusiness.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBusiness.fulfilled, (state, action) => {
        state.loading = false;
        state.businesses.push(action.payload); // Add the new business to the list
      })
      .addCase(createBusiness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch all businesses
      .addCase(fetchBusinesses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBusinesses.fulfilled, (state, action) => {
        state.loading = false;
        state.businesses = action.payload;
      })
      .addCase(fetchBusinesses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch a business by ID
      .addCase(fetchBusinessById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBusinessById.fulfilled, (state, action) => {
        state.loading = false;
        state.business = action.payload; // Set the fetched business
      })
      .addCase(fetchBusinessById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMenuItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenuItems.fulfilled, (state, action) => {
        state.loading = false;
        state.menuItems = action.payload; // Set the fetched menu items
      })
      .addCase(fetchMenuItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Set the error message
      })      // Hours update:
      .addCase(updateBusinessHours.pending, state => {
        state.hoursUpdating = true;
        state.hoursError = null;
      })
      .addCase(updateBusinessHours.fulfilled, (state, action) => {
        state.hoursUpdating = false;
        // overwrite just the hours sub‐document
        if (state.business) state.business.hours = action.payload;
      })
      .addCase(updateBusinessHours.rejected, (state, action) => {
        state.hoursUpdating = false;
        state.hoursError = action.payload;
      });
  
  },
});

export default businessSlice.reducer;
